<template>
    <div class="account-button" v-click-outside="closeDropdown">
        <a v-if="!loggedIn" href="/user/login" class="account-button__trigger" aria-label="Inloggen">
            <svg class="account-button__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_4997_11298" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_4997_11298)">
                    <path d="M4.62 18.12C5.64 17.34 6.78 16.725 8.04 16.275C9.3 15.825 10.62 15.6 12 15.6C13.38 15.6 14.7 15.825 15.96 16.275C17.22 16.725 18.36 17.34 19.38 18.12C20.08 17.3 20.625 16.37 21.015 15.33C21.405 14.29 21.6 13.18 21.6 12C21.6 9.34 20.665 7.075 18.795 5.205C16.925 3.335 14.66 2.4 12 2.4C9.34 2.4 7.075 3.335 5.205 5.205C3.335 7.075 2.4 9.34 2.4 12C2.4 13.18 2.595 14.29 2.985 15.33C3.375 16.37 3.92 17.3 4.62 18.12ZM12 13.2C10.82 13.2 9.825 12.795 9.015 11.985C8.205 11.175 7.8 10.18 7.8 9C7.8 7.82 8.205 6.825 9.015 6.015C9.825 5.205 10.82 4.8 12 4.8C13.18 4.8 14.175 5.205 14.985 6.015C15.795 6.825 16.2 7.82 16.2 9C16.2 10.18 15.795 11.175 14.985 11.985C14.175 12.795 13.18 13.2 12 13.2ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C13.06 21.6 14.06 21.445 15 21.135C15.94 20.825 16.8 20.38 17.58 19.8C16.8 19.22 15.94 18.775 15 18.465C14.06 18.155 13.06 18 12 18C10.94 18 9.94 18.155 9 18.465C8.06 18.775 7.2 19.22 6.42 19.8C7.2 20.38 8.06 20.825 9 21.135C9.94 21.445 10.94 21.6 12 21.6ZM12 10.8C12.52 10.8 12.95 10.63 13.29 10.29C13.63 9.95 13.8 9.52 13.8 9C13.8 8.48 13.63 8.05 13.29 7.71C12.95 7.37 12.52 7.2 12 7.2C11.48 7.2 11.05 7.37 10.71 7.71C10.37 8.05 10.2 8.48 10.2 9C10.2 9.52 10.37 9.95 10.71 10.29C11.05 10.63 11.48 10.8 12 10.8Z" fill="currentColor"/>
                </g>
            </svg>
        </a>

        <template v-else>
            <a
                v-if="isMobile"
                href="/dashboard"
                class="account-button__trigger"
                aria-label="Mijn account"
            >
                <svg class="account-button__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_4997_11298" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_4997_11298)">
                        <path d="M4.62 18.12C5.64 17.34 6.78 16.725 8.04 16.275C9.3 15.825 10.62 15.6 12 15.6C13.38 15.6 14.7 15.825 15.96 16.275C17.22 16.725 18.36 17.34 19.38 18.12C20.08 17.3 20.625 16.37 21.015 15.33C21.405 14.29 21.6 13.18 21.6 12C21.6 9.34 20.665 7.075 18.795 5.205C16.925 3.335 14.66 2.4 12 2.4C9.34 2.4 7.075 3.335 5.205 5.205C3.335 7.075 2.4 9.34 2.4 12C2.4 13.18 2.595 14.29 2.985 15.33C3.375 16.37 3.92 17.3 4.62 18.12ZM12 13.2C10.82 13.2 9.825 12.795 9.015 11.985C8.205 11.175 7.8 10.18 7.8 9C7.8 7.82 8.205 6.825 9.015 6.015C9.825 5.205 10.82 4.8 12 4.8C13.18 4.8 14.175 5.205 14.985 6.015C15.795 6.825 16.2 7.82 16.2 9C16.2 10.18 15.795 11.175 14.985 11.985C14.175 12.795 13.18 13.2 12 13.2ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C13.06 21.6 14.06 21.445 15 21.135C15.94 20.825 16.8 20.38 17.58 19.8C16.8 19.22 15.94 18.775 15 18.465C14.06 18.155 13.06 18 12 18C10.94 18 9.94 18.155 9 18.465C8.06 18.775 7.2 19.22 6.42 19.8C7.2 20.38 8.06 20.825 9 21.135C9.94 21.445 10.94 21.6 12 21.6ZM12 10.8C12.52 10.8 12.95 10.63 13.29 10.29C13.63 9.95 13.8 9.52 13.8 9C13.8 8.48 13.63 8.05 13.29 7.71C12.95 7.37 12.52 7.2 12 7.2C11.48 7.2 11.05 7.37 10.71 7.71C10.37 8.05 10.2 8.48 10.2 9C10.2 9.52 10.37 9.95 10.71 10.29C11.05 10.63 11.48 10.8 12 10.8Z" fill="currentColor"/>
                    </g>
                </svg>
            </a>

            <button
                v-else
                class="account-button__trigger"
                @click="toggleDropdown"
                :aria-expanded="open ? 'true' : 'false'"
                aria-label="Mijn account"
                type="button"
            >
                <svg class="account-button__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_4997_11298" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_4997_11298)">
                        <path d="M4.62 18.12C5.64 17.34 6.78 16.725 8.04 16.275C9.3 15.825 10.62 15.6 12 15.6C13.38 15.6 14.7 15.825 15.96 16.275C17.22 16.725 18.36 17.34 19.38 18.12C20.08 17.3 20.625 16.37 21.015 15.33C21.405 14.29 21.6 13.18 21.6 12C21.6 9.34 20.665 7.075 18.795 5.205C16.925 3.335 14.66 2.4 12 2.4C9.34 2.4 7.075 3.335 5.205 5.205C3.335 7.075 2.4 9.34 2.4 12C2.4 13.18 2.595 14.29 2.985 15.33C3.375 16.37 3.92 17.3 4.62 18.12ZM12 13.2C10.82 13.2 9.825 12.795 9.015 11.985C8.205 11.175 7.8 10.18 7.8 9C7.8 7.82 8.205 6.825 9.015 6.015C9.825 5.205 10.82 4.8 12 4.8C13.18 4.8 14.175 5.205 14.985 6.015C15.795 6.825 16.2 7.82 16.2 9C16.2 10.18 15.795 11.175 14.985 11.985C14.175 12.795 13.18 13.2 12 13.2ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C13.06 21.6 14.06 21.445 15 21.135C15.94 20.825 16.8 20.38 17.58 19.8C16.8 19.22 15.94 18.775 15 18.465C14.06 18.155 13.06 18 12 18C10.94 18 9.94 18.155 9 18.465C8.06 18.775 7.2 19.22 6.42 19.8C7.2 20.38 8.06 20.825 9 21.135C9.94 21.445 10.94 21.6 12 21.6ZM12 10.8C12.52 10.8 12.95 10.63 13.29 10.29C13.63 9.95 13.8 9.52 13.8 9C13.8 8.48 13.63 8.05 13.29 7.71C12.95 7.37 12.52 7.2 12 7.2C11.48 7.2 11.05 7.37 10.71 7.71C10.37 8.05 10.2 8.48 10.2 9C10.2 9.52 10.37 9.95 10.71 10.29C11.05 10.63 11.48 10.8 12 10.8Z" fill="currentColor"/>
                    </g>
                </svg>
            </button>

            <div v-show="!isMobile && open" class="account-button__dropdown">
                <a href="/dashboard" class="account-button__item">Mijn Autohopper</a>
                <a href="/dashboard/account" class="account-button__item">Accountgegevens</a>
                <a :href="logoutUrl" class="account-button__item account-button__item--logout">Uitloggen</a>
            </div>
        </template>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
    name: 'AccountButton',

    directives: { ClickOutside },

    data() {
        return {
            open: false,
            loggedIn: false,
            logoutUrl: '/user/logout',
            isMobile: false,
        };
    },

    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);

        if (typeof drupalSettings !== 'undefined') {
            this.loggedIn = (drupalSettings.user?.uid ?? 0) > 0;

            if (this.loggedIn && drupalSettings.logoutUrl) {
                this.logoutUrl = drupalSettings.logoutUrl;
            }
        }

        this.popupItem = document.querySelector('#page-wrapper > header');
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },

    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth < 1200;
        },

        toggleDropdown() {
            this.open = !this.open;
        },

        closeDropdown() {
            this.open = false;
        },
    },
}
</script>

<style scoped>
.account-button {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 1.5rem;
}

.account-button__trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    line-height: 1;
}

.account-button__icon {
    color: #ffffff;

    @media (min-width: 1200px) {
        color: #033239;
    }
}

.account-button__dropdown {
    position: absolute;
    right: -1rem;
    top: calc(100% + 2rem);
    background: #ffffff;
    border-radius: 10px;
    padding: 1rem;
    min-width: 200px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    gap: 0.666em;

    @media (min-width: 1200px) {
        padding: 2rem;
    }
}

.account-button__item {
    letter-spacing: -4%;
    font-size: 0.875rem;
    font-weight: 400;
    color: #033239;
    text-decoration: none;
    white-space: nowrap;
    display: block;

    @media (min-width: 1200px) {
        font-size: 1rem;
    }
}

.account-button__item:hover,
.account-button__item:focus {
    color: #ed702a;
    text-decoration: none;
}

.account-button__item--logout {
    color: #6c757d;
}

.account-button__item--logout:hover,
.account-button__item--logout:focus {
    color: #ed702a;
}
</style>
